<script setup>
    const { items } = defineProps({
        items: Array,
    })

    items?.unshift({
        label: 'АрендаБЦ',
        to: '/'
    })
</script>
<template>
    <div role="breadcrumb" class="mt-0 relative z-10">
        <div class="py-2 hidden md:block">
            <nav aria-label="Breadcrumb" class="relative min-w-0">
                <ol class="flex flex-wrap items-center gap-1.5">
                <template v-for="item in items">
                    <li v-if="item.to" class="flex items-center gap-1.5 text-white  text-sm leading-6 min-w-0">
                    <nuxt-link :to="item.to" class="flex items-center text-lg font-normal gap-1.5 min-w-0 hover:text-gray-700 dark:hover:text-gray-200">
                        <span class="block truncate font-Montserrat font-semibold text-sm text-brand-dark">{{ item.label }}</span>
                    </nuxt-link>
                    <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 9L5 5L1 1" class="stroke-slate-900" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    </li>
                    <li v-else class="flex items-center gap-1.5 text-slate-100  text-sm leading-6 min-w-0">
                    <span type="button" class="flex items-center gap-1.5 text-lg font-normal min-w-0 text-primary-500 dark:text-primary-400" aria-current="page">
                        <span class="block truncate font-Montserrat text-sm text-brand-dark">{{ item.label }}</span>
                    </span>
                    </li>
                </template>
                </ol>
            </nav>
        </div>

    </div>
</template>